import withAuth from "@/components/shared/utils/Auth/Auth";

export const MyOOSIPage = () => {
  return (
    <div>
      <h1>My OOSI Page</h1>
    </div>
  );
};

export default withAuth(MyOOSIPage);
